import Select from '@components/Form/Select';

type Option = { value: string; label: string };

type Props = {
  label: string;
  id: string;
  options: Option[];
  name: string;
  defaultValue?: string;
  handleChange: (value: string) => void;
  disabled?: boolean;
  emptyText: string;
};

function SeminarSearchFilter(props: Props) {
  const { label, id, emptyText, options, name, defaultValue, disabled, handleChange } = props;

  return (
    <div className='seminar-search-form__filter'>
      <Select
        items={options.map(option => ({
          text: option.label,
          value: option.value,
        }))}
        id={id}
        name={name}
        ariaLabel={label}
        label={label}
        defaultValue={defaultValue}
        onValueChange={handleChange}
        disabled={disabled}
        emptyText={emptyText}
        showEmpty
        variant='search'
      />
    </div>
  );
}

export default SeminarSearchFilter;
